import './App.scss';
import { Route, Switch, BrowserRouter as Router } from 'react-router-dom';
import Tdd from './components/tdd';
import Home from './components/home';
import Footer from './components/layout/footer';
import Header from './components/layout/header';
import Edit from './components/edit';
import { useApp } from './contexts/useApp';

function App() {
  const { state } = useApp();
  return (
    <Router>
      <Header />
      <Switch>
        <Route
          exact
          path="/kata/:id/edit"
          component={() => {
            if (state.profile.username) {
              return <Edit />;
            }
            return <Home />;
          }}
        />
        <Route
          exact
          path="/kata"
          component={() => {
            if (state.profile.username) {
              return <Tdd />;
            }
            return <Home />;
          }}
        />
        <Route
          exact
          path="/kata/:forkid/fork"
          component={() => {
            if (state.profile.username) {
              return <Tdd />;
            }
            return <Home />;
          }}
        />
        <Route exact path="/kata/:slug?/:id?" component={Tdd} />
        <Route exact path="/" component={Home} />
      </Switch>
      <Footer />
    </Router>
  );
}

export default App;
